//import './App.css';
import { Route, Routes, Navigate, useNavigate, useLocation } from "react-router-dom";
import Home from "./pages/home";
import Chat from "./pages/chat";
import AuthPage from "./pages/AuthPage";
import Chat2 from "./pages/chat2";
import Contact from "./pages/contact";
import TypewriterComponent from "typewriter-effect";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ScrollToTop from "./ScrollToTop";
import React, { useEffect } from 'react';
import AIShowcase from "./pages/AIShowcase";

// import Testing2 from "./pages/append/testing2";

function App() {
  const navigate = useNavigate();
  const location = useLocation();

  // ✅ ESC closes auth route
  useEffect(() => {
    const handler = (e) => {
      if (e.key === "Escape" && location.pathname === "/auth") {
        navigate("/", { replace: true });
      }
    };

    document.addEventListener("keydown", handler, true);
    return () => document.removeEventListener("keydown", handler, true);
  }, [location.pathname, navigate]);



  useEffect(() => {
    if (!window.gtagScriptLoaded) {

      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://www.googletagmanager.com/gtag/js?id=G-LYGBCY5BKH';
      document.head.appendChild(script);

      window.dataLayer = window.dataLayer || [];
      function gtag() { window.dataLayer.push(arguments); }
      window.gtag = gtag;
      gtag('js', new Date());
      gtag('config', 'G-LYGBCY5BKH');
      window.gtagScriptLoaded = true;
    }
  }, []);

  useEffect(() => {
    if (window.gtag) {
      window.gtag('config', 'G-LYGBCY5BKH', {
        page_path: location.pathname + location.search,
      });
    }
  }, [location]);

  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        {/* <Route path="/" element={<div>HOME ROUTE OK</div>} /> */}
        <Route path="/chat" element={<Chat />} />
        <Route path="/auth" element={<AuthPage />} />
        {/* <Route path="/chat2" element={<Chat2 />} /> */}
        <Route path="/contact" element={<Contact />} />
        <Route path="/typetest" element={<TypewriterComponent />} />
        <Route path="/ai-test" element={<AIShowcase />} />
        <Route path="/home.html" element={<Navigate to="/" />} />
        <Route path="/home" element={<Navigate to="/" />} />
        {/* <Route path="/testing2" element={<Testing2/>}/> */}
      </Routes>
    </>
  );
}

export default App;
